// extracted by mini-css-extract-plugin
export default {"otpContainer":"OTPInput_otpContainer__cTRrU","hiddenInput":"OTPInput_hiddenInput__SD8ke","otpInput":"OTPInput_otpInput__FBN9W"};